import React from 'react';
import { useSelector } from 'react-redux';

import { EditOutlined } from '@ant-design/icons';

import { RibbonButton } from 'common/components';

import { useGlobalModal } from 'hooks';
import { useCheckDisabledMasterAplBtn } from './hooks';

import gridViewSelectors from 'common/components/grid-view/controllers/selectors';
import { MASTER_APL_NAME } from './constants';

const EditAPLRibbon = () => {
  const { openModal, MODAL_NAMES } = useGlobalModal();

  const selectedProducts = useSelector(
    gridViewSelectors.makeSelectDetailCurrentITemsSelection()
  );

  const isOwner = selectedProducts?.[0]?.isOwner;

  const isMasterApl = selectedProducts?.[0]?.aplName === MASTER_APL_NAME;

  const isDisabledMasterAplBtn = useCheckDisabledMasterAplBtn({
    ...selectedProducts,
    companyId: selectedProducts?.[0]?.ownerCompanyId,
  });

  const checkDisabled = () => {
    if (selectedProducts.length !== 1) return true;

    if (isMasterApl) return isDisabledMasterAplBtn;

    return !isOwner;
  };
  const isDisabled = checkDisabled();
  return (
    <RibbonButton
      size='small'
      icon={<EditOutlined />}
      label={'Edit APL'}
      onClick={() => openModal(MODAL_NAMES.EDIT_APL)}
      disabled={isDisabled}
    />
  );
};

export default EditAPLRibbon;
